<template>
    <div class="main">
        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Stock Adjustment</h3>
            </div>
            <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">

                <a-button @click="showAddStockAdjustmentModal"
                    style="height:38px;margin-right: 10px;border-raduis:5px; background: #418a49; color:#fff;"
                    icon="plus">
                    Add Stock Adjustment
                </a-button>
                <a-button @click="exportStockData"
                    style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                    Export
                </a-button>
            </div>
            <div>
                <a-table :columns="columns" :data-source="tableStockAdjustment" :loading='tableLoading'
                    :scroll="{ x: 1500, y: 600 }" :pagination="pagination" class="tableStyle">
                    <div slot="filterDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px">
                        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                            Search
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                            Reset
                        </a-button>
                    </div>

                    <div slot="filterCategoryDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px">
                        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                            Search
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                            Reset
                        </a-button>
                    </div>

                    <div slot="filterSupplierDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px">
                        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                            Search
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                            Reset
                        </a-button>
                    </div>
                    <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                        style="padding: 8px;display: flex;flex-direction: column;">
                        <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
                            <a-select-option value="all">
                                All
                            </a-select-option>
                            <a-select-option value="1">
                                Approved
                            </a-select-option>
                            <a-select-option value="0">
                                UnApproved
                            </a-select-option>
                            <a-select-option value="2">
                                Cancelled
                            </a-select-option>
                        </a-select>
                    </div>
                    <template slot="action" slot-scope="data">
                        <div v-if="data.status === 0">
                            <a-dropdown>
                                <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                </a>
                                <a-menu slot="overlay">
                                    <a-menu-item>
                                        <a @click="approveStockAdjustment(data)">Approve?</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="cancelStockAdjustment(data)">Cancel?</a>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </div>
                        <div v-else>
                            N/A
                        </div>

                    </template>

                    <template slot="status" slot-scope="data">
                        <status-component v-if="data" :status="data"></status-component>
                    </template>
                    <template slot="typeLabel" slot-scope='data'>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #ddf1dd;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `Returned`">
                            <!-- <p style="width: 9px;height: 9px;background: #2ca62d;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#2ca62d;"> {{ data }}</p>
                        </div>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `TransferredOut`">
                            <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#ffb102;"> {{ data }}</p>
                        </div>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `Lost`">
                            <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#41c4fd;"> {{ data }}</p>
                        </div>

                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #ff000073;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `Damaged`">
                            <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#fff;">{{ data }}</p>
                        </div>
                        <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #0096889e;width: 140px;height: 27px;border-radius: 30px"
                            v-if="data === `TransferredIn`">
                            <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
                            <p style="font-size:12px;color:#fff;">{{ data }}</p>
                        </div>

                    </template>

                </a-table>
            </div>
            <a-modal class="modalStyle" :visible="addStockAdjustmentVisible" :footer="null" width="800px"
                @cancel="handleAddStockAdjustmentCancel">

                <h4
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Add Stock Adjustment</h4>
                <div>
                    <a-form-model ref="addStockAdjustmentForm" :model="addStockAdjustmentModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Distribution Centers" ref="locationId" prop="locationId">
                                    <a-select v-model="addStockAdjustmentModel.locationId"
                                        placeholder="please select your option">
                                        <a-select-option v-for="center in availableDistCenters" :key="center.locationId"
                                            v-bind:value="center.locationId">
                                            {{ center.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Type" ref="type" prop="type">
                                    <a-select v-model="addStockAdjustmentModel.type"
                                        placeholder="please select your option">
                                        <a-select-option value="0">
                                            Damaged
                                        </a-select-option>
                                        <a-select-option value="1">
                                            Lost
                                        </a-select-option>
                                        <a-select-option value="2">
                                            TransferredOut
                                        </a-select-option>
                                        <a-select-option value="3">
                                            Returned
                                        </a-select-option>
                                        <a-select-option value="4">
                                            TransferredIn
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Products" ref="productId" prop="productId">
                                    <a-select v-model="addStockAdjustmentModel.productId"
                                        placeholder="please select your option">
                                        <a-select-option v-for="product in availableClientProducts" :key="product.id"
                                            v-bind:value="product.id">
                                            {{ product.brandName }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Quantity" ref="quantity" prop="quantity">
                                    <a-input class="" v-model="addStockAdjustmentModel.quantity" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="22" :offset="1">

                                <a-form-model-item label="Notes" ref="notes" prop="notes">
                                    <a-textarea v-model="addStockAdjustmentModel.notes" placeholder="Enter notes...."
                                        :auto-size="{ minRows: 3, maxRows: 5 }" />
                                </a-form-model-item>

                            </a-col>

                        </a-row>

                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <!-- <a-spin class="spinner" :spinning="loading" /> -->
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button :loading="loading" @click="handleStockAdjSumit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Add Stock Adjustment
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
            <a-modal class="modalStyle" :visible="editUserVisible" :footer="null" @cancel="handleEditUserCancel">
                <div style="display:flex;justify-content: center;">
                    <img class="img_size"
                        src="../../assets/img/illo_sm_employees_3_3554528_c_9_f_99_ede_44_e_2797833410_a_520.svg" />
                </div>
                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Edit User?</p>
                <div>
                    <a-form-model ref="editUserForm" :model="editUserModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Name" ref="name" prop="name">
                                    <a-input class="" v-model="editUserModel.name" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="2">
                                <a-form-model-item label="Phone Number" ref="phoneNumber" prop="phoneNumber">
                                    <a-input class="" v-model="editUserModel.phoneNumber" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Gender" ref="gender" prop="gender">
                                    <a-select v-model="editUserModel.gender" placeholder="please select your gender">
                                        <a-select-option value="male">
                                            Male
                                        </a-select-option>
                                        <a-select-option value="female">
                                            Female
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>

                        </a-row>

                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleEditUserSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Edit User
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
            <a-modal class="modalStyle" :visible="changePasswordVisible" :footer="null"
                @cancel="handleChangePasswordCancel">
                <div style="display:flex;justify-content: center;">
                    <img class="img_size"
                        src="../../assets/img/illo_sm_employees_3_3554528_c_9_f_99_ede_44_e_2797833410_a_520.svg" />
                </div>
                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Change Password?
                </p>
                <div>
                    <a-form-model ref="changePasswordForm" :model="changePassswordModel" :rules="rules">
                        <a-row>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="New Password" ref="newPassword" prop="newPassword">
                                    <a-input class="" type="password" v-model="changePassswordModel.newPassword" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="22" :offset="1">
                                <a-form-model-item label="Confirm Password" ref="confirmPassword"
                                    prop="confirmPassword">
                                    <a-input class="" type="password" v-model="changePassswordModel.confirmPassword" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>


                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleChangePasswordSubmit"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Change Password
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import XLSX from "xlsx";
import StatusComponent from '../shared-components/StatusComponent.vue'

const columns = [
  {
    title: "Product Name",
    width: 200,
    dataIndex: 'productName',
    key: 'productName',
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.productName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
  },
//   {
//     title: 'Category',
//     dataIndex: 'productCategoryName',
//     key: 'productCategoryName',
//     scopedSlots: {
//     filterDropdown: 'filterCategoryDropdown',
//     filterIcon: 'filterIcon',
//     },
//     width: 100,
//     onFilter: (value, record) =>
//         record.productCategoryName
//             .toString()
//             .toLowerCase()
//             .includes(value.toLowerCase()),
//   },
//   {
//     title: 'Supplier',
//     dataIndex: 'productSupplierName',
//     key: 'productSupplierName',
//     scopedSlots: {
//     filterDropdown: 'filterSupplierDropdown',
//     filterIcon: 'filterIcon',
//     },
//     width: 100,
//     onFilter: (value, record) =>
//         record.productSupplierName
//             .toString()
//             .toLowerCase()
//             .includes(value.toLowerCase()),
//   },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
      width: 100,
  },
  {
    title: 'Type',
    dataIndex: 'typeLabel',
    key: 'typeLabel',
    scopedSlots: { customRender: 'typeLabel' },
      width: 200,
  },
  {
    title: 'Distribution Center',
    dataIndex: 'locationName',
    key: "locationName",
      width: 200,
  },
  {
    title: 'Approved By',
    dataIndex: 'approvedByName',
    key: "approvedByName",
      width: 200,
  },
    {
    title: 'Approved At',
    dataIndex: 'approvedAt',
    key: "approvedAt",
        width: 200,
  },
  {
    title: 'Status',
    dataIndex: 'status',
      width: 200,
    scopedSlots: {
    customRender: "status",
    filterDropdown: 'filterStatusDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.status
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    // width: 100,
  },
  {
    title: 'Date Created',
    dataIndex: 'createdAt',
    key: "createdAt",
      width: 200,
  },
  {
    title: 'Action',
    dataIndex: 'action',
    width: 100,
    scopedSlots: { customRender: 'action' }
  }

];

    export default {
        name: 'StockAdjustment',
        components:{
            StatusComponent
        },
        data(){
            return{
                tableStockAdjustment: [],
                availableClientProducts:[],
                availableDistCenters:[],
                tableLoading: false,
                columns,
                searchText:'',
                searchInput: null,
                searchedColumn: '',
                pagination: {
                    pageSize:20
                },
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
                addStockAdjustmentModel: {
                    locationId: '',
                    type: '',
                    productId:'',
                    quantity:'',
                    notes:''
				},
                editUserModel: {
                    name: '',
                    phoneNumber:'',
                    gender:''
				},
                changePassswordModel:{
                    newPassword: '',
                    confirmPassword: ''
                },
                selectedUser: {},
                availableStockAdjustments: [],
                addStockAdjustmentVisible: false,
                editUserVisible: false,
                disableUserVisible: false,
                changePasswordVisible: false,
                dateFormat: 'DD/MM/YYYY',
                startDate: moment(),
                endDate: moment(),
                loading: false,
                rules: {
                    locationId: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    type: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    productId: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    quantity: [
                        { required: true, message: 'Please enter quantity', trigger: 'change' }
                    ],
                
                },
            }
        },
        computed:{
            ...mapGetters(['IsAgentProfileAvailable']),
        },
        methods:{
          ...mapActions(['getAllStockAdjustment','getClientProductAndDistCenters','addNewStockAdjustment','updateStockAdjustment']),
          onChange(date, dateString) {
                // console.log(date, dateString);
                this.startDate = dateString[0];
                this.endDate = dateString[1];
                // console.log("startDate | ", this.startDate);
                // console.log("endDate | ", this.endDate);
            },
            moment,
            handleSearch(selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            showEditProfileModal(user){
                this.selectedUser = user
                this.editUserModel.name = user.name
                this.editUserModel.phoneNumber = user.phoneNumber
                this.editUserModel.gender = user.gender
                this.editUserVisible = true;
                // this.setCustomerInfo(data)
                // this.$router.push('/customer-history').catch(()=>{});
            },
            showChangePassword(user){
                this.selectedUser = user
                 this.changePasswordVisible = true
            },

            onInventoryChange(value, clearFilters){
                let result = []
                if(value === 'all'){
                    result = this.availableStockAdjustments
                }else {
                    result = this.availableStockAdjustments.filter(invoice => parseInt(invoice.status) === parseInt(value) )
                }
                this.tableStockAdjustment = result.map(stock => ({
                        key: stock.id,
                        productName: stock.productName,
                        quantity: stock.quantity,
                        typeLabel: stock.typeLabel,
                        locationName: stock.locationName,
                        productCategoryName: stock.productCategoryName ? stock.productCategoryName : 'N/A',
                        productSupplierName: stock.productSupplierName ? stock.productSupplierName : 'N/A',
                        approvedByName: stock.approvedByName ? stock.approvedByName : 'N/A',
                        approvedAt: stock.approvedAt ? moment(stock.approvedAt).format('DD-MM-YYYY') : 'N/A',
                        status: stock.statusLabel,
                        createdAt: moment(stock.createdAt).format('DD-MM-YYYY'),
                        action: stock
                    }))
                clearFilters();
            },

            exportStockData(){
                const dataToExport = [
                    [
                        "Product Name",
                        "Quantity",
                        "Type",
                        "Distribution Center",
                        "Approved By",
                        "Approved At",
                        "Status",
                        "Date Cretaed"
                    ],
                ];
                this.tableStockAdjustment.forEach((v) => {
                    dataToExport.push([
                        v.productName,
                        v.quantity,
                        v.typeLabel,
                        v.locationName,
                        v.approvedByName,
                        v.approvedAt,
                        v.status,
                        v.createdAt
                    ]);
                });

                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(dataToExport);

                /* Add the worksheet to the workbook */
                XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                /* generate file and send to client */
                XLSX.writeFile(wb, `Export-Stock-Adjustment-${moment().format('DD-MM-YYYY')}.xlsx`);
                this.showSuccessAlert("Data Successfully Exported")
            },
           
            showAddStockAdjustmentModal(){
                this.addStockAdjustmentVisible = true;
            },
            handleChangePasswordCancel(){
                this.changePasswordVisible = false
            },
            handleAddStockAdjustmentCancel() {
                // console.log('Clicked cancel button');
                this.addStockAdjustmentVisible = false;
            },
            handleEditUserCancel() {
                // console.log('Clicked cancel button');
                this.editUserVisible = false;
            },
            handleStockAdjSumit() {
                this.$refs.addStockAdjustmentForm.validate(valid => {
                    if (valid) {
                        this.loading = true
                        // console.log("newAgent | ", this.newAgent)
                        // console.log("addStockAdjustmentModel | ", this.addStockAdjustmentModel)

                        let request_data = {
                            locationId: this.addStockAdjustmentModel.locationId,
                            type: parseInt(this.addStockAdjustmentModel.type),
                            productId: this.addStockAdjustmentModel.productId,
                            quantity: parseInt(this.addStockAdjustmentModel.quantity) ,
                            status: 0,
                            notes: this.addStockAdjustmentModel.notes
                        }

                        // console.log("request_data | ", request_data)
                        this.addNewStockAdjustment(request_data).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getAllStockAdjustmentData();
                                this.addStockAdjustmentVisible = false;
                                this.showSuccessAlert("New stock adjustment added successfully")
                                this.$refs.addStockAdjustmentForm.resetFields();
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })
                    } else {
                        // console.log('error submit!!');
                        this.loading = false;
                        return false;
                    }
                });
            },
            
            handleEditUserSubmit() {
                this.$refs.editUserForm.validate(valid => {
                    if (valid) {
                        this.loading = true
                        // console.log("newAgent | ", this.newAgent)
                        // console.log("IsAgentProfileAvailable | ", this.IsAgentProfileAvailable)
                        

                        let request_data = {
                            userId: this.selectedUser.id,
                            data: {
                                id: this.selectedUser.id,
                                name: this.editUserModel.name,
                                description: this.selectedUser.description,
                                phoneNumber: this.editUserModel.phoneNumber,
                                gender: this.editUserModel.gender,
                                roles: [ process.env.VUE_APP_CLIENT_USER_ROLE ],
                            }
                        }

                        // console.log("request_data | ", request_data)
                        
                        this.updateClientUser(request_data).then(response => {
                            
                            this.loading = false;
                            if(response.status === 200){
                                this.getClientUsers();
                                this.editUserVisible = false;
                                this.showSuccessAlert("User profile updated successfully")
                            }else{
                                this.showErrorAlert(response.data.messages)
                            }
                        },
                        error =>{
                            this.loading = false
                            this.showErrorAlert(JSON.stringify(error))
                        })
                    } else {
                        // console.log('error submit!!');
                        this.loading = false;
                        return false;
                    }
                });
            },
            
            handleChangePasswordSubmit() {
                this.$refs.changePasswordForm.validate(valid => {
                    if (valid) {
                        if(this.changePassswordModel.newPassword !== this.changePassswordModel.confirmPassword){
                            // this.changePasswordVisible = false
                            this.showErrorAlert("Password do not match")
                        }else{
                            this.loading = true
                            let request_data = {
                                userId: this.selectedUser.id,
                                data: {
                                    password: this.changePassswordModel.newPassword,
                                }
                            }

                            // console.log("request_data | ", request_data)
                            
                            this.changeUserPassword(request_data).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.getClientUsers();
                                    this.changePasswordVisible = false;
                                    this.showSuccessAlert("User password changed successfully")
                                    
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })
                        }
                        
                    } else {
                        // console.log('error submit!!');
                        this.loading = false;
                        return false;
                    }
                });
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            handleTableChange(pagination) {
                this.tableLoading = true
                // console.log("pagination in change | ", pagination);
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.params.page = pagination.current;
                this.params.perPage = pagination.pageSize;

                this.getClientUsersRequests(this.params).then(response => {
                    this.tableLoading = false;
                    // console.log('response  | ', response)
                    if(response.status === 200){
                        const pagination = {...this.pagination}
                        pagination.total = response.data.totalRecords;
                        let result = []
                        if(response.data.data.length !== 0){
                            result = response.data.data
                        }
                        let finalUserRequestList = [];

                        result.forEach(request => {

                            let userObject = {}
                            userObject['key'] = request.id
                            userObject['name'] = request.name
                            userObject['phoneNumber'] = request.phoneNumber
                            userObject['email'] = request.email,
                            userObject['gender'] = request.gender
                            userObject['status'] = request.isActive
                            userObject['createdAt'] = moment(request.createdAt).format("DD-MMM-YYYY");
                            
                            // orderRquestObject['action'] = request

                            finalUserRequestList.push(userObject)

                        })
                        this.users = finalUserRequestList
                        this.pagination = pagination;
                    }else{
                        this.tableLoading = false;
                        console.log('Error | ', response)
                    }

                },
                error => {
                    this.tableLoading = false;
                    console.log('Error | ', error)
                })
            },
            async approveStockAdjustment(data){
                this.tableLoading = true
                let request_data = {
                    id: data.id,
                    data: {
                        status: 1,
                    }
                }

                // console.log("request_data | ", request_data)
                
                this.updateStockAdjustment(request_data).then(response => {
                    
                    this.tableLoading = false;
                    if(response.status === 200){
                        this.getAllStockAdjustmentData();
                        this.showSuccessAlert("Stock adjustment updated successfully")
                    }else{
                        this.showErrorAlert(response.data.messages)
                    }
                },
                error =>{
                    this.tableLoading = false
                    this.showErrorAlert(error.response.data.messages)
                    
                })
            },
            cancelStockAdjustment(data){
                this.tableLoading = true
                let request_data = {
                    id: data.id,
                    data: {
                        status: 2,
                    }
                }

                // console.log("request_data | ", request_data)
                
                this.updateStockAdjustment(request_data).then(response => {
                    
                    this.tableLoading = false;
                    if(response.status === 200){
                        this.getAllStockAdjustmentData();
                        this.showSuccessAlert("Stock adjustment updated successfully")
                    }else{
                        this.showErrorAlert(response.data.messages)
                    }
                },
                error =>{
                    this.tableLoading = false
                    this.showErrorAlert(error.response.data.messages)
                })
            },
            async getClientProducts(response){
                if(response.status === 200){
                    
                    this.availableClientProducts = await response.data.data
                }else{
                console.log("Error 1| " , response)
                }
            },

            async getAllDistributionCenters(response){
                if(response.status === 200){
                    this.availableDistCenters = await response.data.data
                }else{
                console.log("Error 2| " , response)
                }
            },
            async getAllStockAdjustmentData(){
                this.tableLoading = true;
        
                const response =  await this.getAllStockAdjustment()
                this.tableLoading = false;
                if(response.status === 200){
                    this.availableStockAdjustments = response.data.data
                    this.tableStockAdjustment = response.data.data.map(stock => ({
                        key: stock.id,
                        productName: stock.productName,
                        quantity: stock.quantity,
                        typeLabel: stock.typeLabel,
                        locationName: stock.locationName,
                        productCategoryName: stock.productCategoryName ? stock.productCategoryName : 'N/A',
                        productSupplierName: stock.productSupplierName ? stock.productSupplierName : 'N/A',
                        approvedByName: stock.approvedByName ? stock.approvedByName : 'N/A',
                        approvedAt: stock.approvedAt ? moment(stock.approvedAt).format('DD-MM-YYYY') : 'N/A',
                        status: stock.statusLabel,
                        createdAt: moment(stock.createdAt).format('DD-MM-YYYY'),
                        action: stock
                    }))
                }else{
                    console.log("Error | ",response)
                }
            },
            async loadClientAndDistCenters(){
                const response = await this.getClientProductAndDistCenters(this.params)
                
                this.getClientProducts(response[0])
                this.getAllDistributionCenters(response[1])
            }

        },
        created() {
          
          if(this.getAllStockAdjustmentData){
              this.getAllStockAdjustmentData();
          }
          if(this.getClientProductAndDistCenters){
              this.loadClientAndDistCenters()
          }
        }
    }
</script>

<style scoped>

.actions{
    display: flex;
    justify-content: space-between;
}
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.tableStyle >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
    color: #fff;
}
.tableStyle >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
a {
  color: #418a49;
}
a:hover{
  color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}


</style>